<script lang="ts">
  import SidebarCashier from "@frontend/Sidebar/SidebarCashier.svelte";
  import { onMount } from "svelte";
  import { service } from "./services";
  import SidebarAdmin from "./Sidebar/SidebarAdmin.svelte";
  import SidebarDefault from "./Sidebar/SidebarDefault.svelte";
  import { me } from "./user";
  import type { User } from "./walletapi";
  import { translate } from "./Translator";

let users : User [];

async function Users() {
  if(service.walletapi == null) {
    return
  }
  let users = await service.walletapi.listAllUsers({
    Token: sessionStorage.token
  });
}

onMount(() => {
  Users();
});

</script>

<div class="toc">
  <div class="ui vertical labeled icon menu">
    <!-- Debug info -->
    <div class="debug-info">
      User Role: {$me?.Role || 'No role'}
      <br>
      User Name: {$me?.FirstName} {$me?.LastName}
    </div>
    
    <!-- Conditional sidebar rendering based on user role -->
    {#if $me?.Role === 'Cashier'}
      <SidebarCashier />
    {:else if $me?.Role === 'Admin'}
      <SidebarAdmin />
    {:else if $me?.Role === 'Owner'}
      <SidebarDefault />
    {:else}
      <!-- Fallback for unknown roles -->
      <SidebarDefault />
    {/if}
  </div>    
</div>

<style>
    .toc {
        background-color: #1b1c1d;
        height: 100vh;
        width: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        box-shadow: 2px 0 5px rgba(0,0,0,0.1);
        display: flex;
        flex-direction: column;
        scrollbar-width: thin;
        scrollbar-color: rgba(255,255,255,0.3) transparent;
        padding-bottom: 30px; /* Reduced space to allow normal flow */
    }

    /* Custom scrollbar for webkit browsers */
    .toc::-webkit-scrollbar {
        width: 6px;
    }

    .toc::-webkit-scrollbar-track {
        background: transparent;
    }

    .toc::-webkit-scrollbar-thumb {
        background-color: rgba(255,255,255,0.3);
        border-radius: 3px;
    }

    .toc::-webkit-scrollbar-thumb:hover {
        background-color: rgba(255,255,255,0.5);
    }

    :global(.ui.vertical.labeled.icon.menu) {
        width: 100%;
        height: auto;
        min-height: 100vh;
        background-color: #1b1c1d;
        display: flex !important;
        flex-direction: column !important;
        overflow: visible !important;
        flex: 1;
    }

    /* Ensure menu items are visible in desktop */
    @media (min-width: 769px) {
        :global(.ui.vertical.labeled.icon.menu) {
            overflow: visible !important;
            height: auto !important;
            min-height: 100vh !important;
        }
        
        :global(.ui.vertical.labeled.icon.menu .item.mini) {
            display: flex !important;
            visibility: visible !important;
            opacity: 1 !important;
        }
    }

    .debug-info {
        color: white;
        padding: 1em;
        font-size: 0.8em;
        background-color: rgba(255,255,255,0.1);
        margin: 0.5em;
        border-radius: 4px;
        text-align: center;
    }

    /* Hide user info on large screens */
    @media (min-width: 769px) {
        .debug-info {
            display: none;
        }
    }

    /* Show user info on mobile */
    @media (max-width: 768px) {
        .debug-info {
            display: block;
            font-size: 0.9em;
            padding: 0.8em;
            margin: 0.3em;
        }
    }

    /* Ensure all menu items are always visible */
    :global(.item.mini) {
        padding: 0.75rem 1rem !important;
        font-size: 0.9em !important;
        display: flex !important;
        align-items: center !important;
        color: #ffffff !important;
        text-decoration: none !important;
        transition: all 0.2s ease !important;
        border-radius: 0 !important;
        margin: 0 !important;
        min-height: 48px;
        visibility: visible !important;
        opacity: 1 !important;
    }

    /* Specific styles for profile link - ALWAYS VISIBLE */
    :global(.item.mini[href="#/UserPerfil"]) {
        display: flex !important;
        visibility: visible !important;
        opacity: 1 !important;
        position: relative !important;
        z-index: 10 !important;
    }

    /* Force profile visibility on desktop */
    @media (min-width: 769px) {
        :global(.item.mini[href="#/UserPerfil"]) {
            display: flex !important;
            visibility: visible !important;
            opacity: 1 !important;
            height: auto !important;
            overflow: visible !important;
        }
    }

    /* Ensure all menu items are visible in all sidebar components */
    :global(.toc .item.mini) {
        display: flex !important;
        visibility: visible !important;
        opacity: 1 !important;
    }

    :global(.sidebar-menu .item.mini) {
        display: flex !important;
        visibility: visible !important;
        opacity: 1 !important;
    }

    :global(.menu-section .item.mini) {
        display: flex !important;
        visibility: visible !important;
        opacity: 1 !important;
    }

    :global(.icon-container) {
        width: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 0.75rem;
        flex-shrink: 0;
    }

    :global(.item.mini i.icon) {
        margin: 0 !important;
        font-size: 1.1em !important;
    }

    :global(.item.mini:hover) {
        background-color: rgba(255,255,255,0.1) !important;
        /* Removed transform movement effect */
    }

    :global(.item.mini span) {
        flex: 1;
        font-weight: 500;
        letter-spacing: 0.3px;
    }

    /* Mobile responsive styles */
    @media (max-width: 768px) {
        .toc {
            padding-top: 3em; /* Account for top nav */
        }

        :global(.ui.vertical.labeled.icon.menu) {
            width: 100%;
            height: 100%;
        }
    }

    @media (min-width: 769px) {
        .toc {
            width: 150px;
        }
    }

    /* SUPER AGGRESSIVE profile visibility - highest priority */
    :global(.toc .ui.vertical.labeled.icon.menu .item.mini[href="#/UserPerfil"]) {
        display: flex !important;
        visibility: visible !important;
        opacity: 1 !important;
        position: relative !important;
        z-index: 999 !important;
        height: auto !important;
        overflow: visible !important;
        background-color: rgba(255,255,255,0.1) !important;
    }

    :global(.toc .ui.vertical.labeled.icon.menu .sidebar-menu .item.mini[href="#/UserPerfil"]) {
        display: flex !important;
        visibility: visible !important;
        opacity: 1 !important;
        position: relative !important;
        z-index: 999 !important;
        height: auto !important;
        overflow: visible !important;
        background-color: rgba(255,255,255,0.1) !important;
    }

    :global(.toc .ui.vertical.labeled.icon.menu .menu-section .item.mini[href="#/UserPerfil"]) {
        display: flex !important;
        visibility: visible !important;
        opacity: 1 !important;
        position: relative !important;
        z-index: 999 !important;
        height: auto !important;
        overflow: visible !important;
        background-color: rgba(255,255,255,0.1) !important;
    }

    /* Force ALL profile links to be visible regardless of parent */
    :global([href="#/UserPerfil"]) {
        display: flex !important;
        visibility: visible !important;
        opacity: 1 !important;
        position: relative !important;
        z-index: 999 !important;
        height: auto !important;
        overflow: visible !important;
        background-color: rgba(255,255,255,0.1) !important;
    }

    /* Ensure profile is always visible at the bottom */
    :global(.item.mini[href="#/UserPerfil"]) {
        margin-bottom: 10px !important;
        position: relative !important;
        z-index: 9999 !important;
    }

    /* Force the last menu item to be visible */
    :global(.menu-section:last-child .item.mini:last-child) {
        margin-bottom: 10px !important;
        padding-bottom: 10px !important;
    }
</style>
